import { RumInitConfiguration } from '@datadog/browser-rum';
import { Environment } from 'environments/environment-base';
import { scrubRumErrorEvent, shouldDiscardRumEvent } from './csp-noise-filter';
import { scrubViewUrls } from './rum-privacy-filter';
import { keepRumResource } from './rum-resource-filter';

/**
 * Builds the Datadog RUM init configuration for a given environment + release version.
 *
 * Pure function (no SDK calls, no side effects) so the configuration can be asserted
 * in unit tests without initialising the RUM SDK.
 */
export function buildRumConfig(environment: Environment, version: string): RumInitConfiguration {
    const apiOrigins = [environment.api.baseUrl, environment.api.identityServiceUrl, environment.quoteServiceHost]
        .filter(Boolean)
        .map(url => new URL(url).origin);

    return {
        applicationId: environment.datadogApplicationId,
        clientToken: environment.datadogClientToken,
        service: 'broker-ui',
        env: environment.fullEnvName,
        version,
        trackUserInteractions: true,
        trackResources: true,
        silentMultipleInit: true,
        allowedTracingUrls: [environment.api.baseUrl],
        trackSessionAcrossSubdomains: true,
        useSecureSessionCookie: true,
        useCrossSiteSessionCookie: true,
        storeContextsAcrossPages: true,
        // beforeSend scrubs the event in place, then returns false to discard it.
        beforeSend: event => {
            scrubViewUrls(event);
            scrubRumErrorEvent(event);
            return !shouldDiscardRumEvent(event) && keepRumResource(event, apiOrigins);
        }
    };
}
